import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DistrictAdminSchool {
  id: number | null
  name: string | null
  numActiveTeachers: number | null
  numActiveStudents: number | null
  numFocusSessionsByWeek: number[] | null
}

export const selectSchools = (state: any) => state.districtSchools
export const selectSchool = (id: number) => (state: any) => state.districtSchools.find((school: DistrictAdminSchool) => school.id === id)

const initialState: DistrictAdminSchool[] = [{
    id: null,
    name: null,
    numActiveTeachers: null,
    numActiveStudents: null,
    numFocusSessionsByWeek: null,
}]

const schoolsSlice = createSlice({
    name: 'districtSchools',
    initialState,
    reducers: {
        loadSchools: (state, {
            payload: schools,
        }: PayloadAction<any[]>) => schools.map((school: any) => ({
            id: school.id,
            name: school.name,
            numActiveTeachers: school.numActiveTeachers,
            numActiveStudents: school.numActiveStudents,
            numFocusSessionsByWeek: school.numFocusSessionsByWeek,
        })),
    },
})

export const { loadSchools } = schoolsSlice.actions

export default schoolsSlice.reducer
